import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalTabSelect } from "../modals/actionModal";
import { IdLibraryCategory } from "./IdLibraryCategory";
var _ButtonResearchItemUpgradeLibrary = function (_a) {
    var openLibraryUpgradeTab = _a.openLibraryUpgradeTab;
    return (React.createElement("div", { className: "button-ribbon" },
        React.createElement(ButtonPrimary, { onClick: openLibraryUpgradeTab },
            React.createElement(TextLoca, { id: IdLoca.upgrade, className: IdStyles.TextButtonDefault }))));
};
var mapDispatch = function (dispatch) { return ({
    openLibraryUpgradeTab: function () { return dispatch(actionModalTabSelect(IdLibraryCategory.Upgrade)); },
}); };
export var ButtonResearchItemUpgradeLibrary = connect(undefined, mapDispatch)(_ButtonResearchItemUpgradeLibrary);



//////////////////
// WEBPACK FOOTER
// ./src/features/library/ButtonResearchItemUpgradeLibrary.tsx
// module id = 2695
// module chunks = 3